<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5" shaped>
            <v-row dense>
              <v-col cols="12">
                <strong>AAM - MANAGE ROLE</strong>
              </v-col>
            </v-row>
            <hr />
            <v-row class="mt-4">
              <v-col cols="12" md="auto">Find By:</v-col>
              <v-col cols="6" md="3">
                <v-autocomplete
                  color="red darken-1"
                  v-model="branch"
                  :items="branchList"
                  item-text="BRANCH_CODE"
                  :return-object="true"
                  label="Branch"
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" md="3">
                <v-text-field
                  color="red darken-1"
                  v-model="position"
                  label="Position"
                  required
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="2">
                <v-btn
                  @click="filterDataTable"
                  outlined
                  color="indigo lighten-1"
                  :disabled="dtLoading"
                  >Load List</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <v-card-title>
                    Role List
                    <v-btn
                      class="ml-2"
                      @click="dowloadCSV()"
                      outlined
                      color="indigo lighten-1"
                      :disabled="dtLoading"
                      >Export Data</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-text-field
                      color="red darken-1"
                      v-model="searchRole"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="dtHeaders"
                    :items="dtItems"
                    :search="searchRole"
                    :loading="dtLoading"
                    loading-text="Fetching Data..."
                    dense
                  >
                    <template v-slot:item.edit="{ item }">
                      <v-icon small class="mr-2" @click="editItem(item.ROLE_MAP_ID)"
                        >mdi-pencil</v-icon
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

const dtHeaders = [
  {
    text: "Position",
    value: "ROLE_POSITION_CODE",
  },
  {
    text: "Type",
    value: "EMPLOYEE_TYPE_CODE",
  },
  {
    text: "Title",
    value: "EMPLOYEE_TITLE_CODE",
  },
  {
    text: "Start Date",
    value: "ROLE_START_DATE",
  },
  {
    text: "End Date",
    value: "ROLE_END_DATE",
  },
  {
    text: "Branch",
    value: "BRANCH_CODE",
  },
  {
    text: "Supervisor",
    value: "ROLE_SUP_CODE",
  },
  {
    text: "CSO",
    value: "CSO_CODE",
  },
  {
    text: "Additional Type",
    value: "ROLE_ADD_TYPE_CODE",
  },
  {
    text: "Collector",
    value: "IS_COLECTOR",
  },
  {
    text: "Edit",
    value: "edit",
    sortable: false,
  },
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      branchList: [],
      branch: null,
      searchRole: "",
      dtLoading: false,
      dtHeaders,
      dtItems: [],
      position: "",
    };
  },
  mounted() {
    this.loadBranchList();
  },
  methods: {
    dowloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItems);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Overview Role.xlsx"); // initiate a file download in browser
    },
    loadBranchList() {
      this.isLoading = true;
      this.$http
        .get("/structure/role/getBranchList", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          this.isLoading = false;
          let { data } = res.data;
          data.unshift({
            ORG_ID: -1,
            BRANCH_CODE: "ALL BRANCH",
            BRANCH_DESC: "ALL BRANCH",
          });
          this.branch = data[0];
          this.branchList = data;
          this.filterDataTable();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err.toString());
        });
    },
    filterDataTable() {
      this.dtLoading = true;
      const data = {
        branch: this.branch.BRANCH_CODE == "ALL BRANCH" ? 0 : this.branch.BRANCH_CODE,
        position: this.position,
      };
      this.$http
        .post("/structure/role/selectRole", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          let { data } = res.data;
          if (data.length <= 0) {
            this.dtLoading = false;
            this.dtItems = [];
          }
          data.forEach((obj, index) => {
            data[index].ROLE_START_DATE = moment(data[index].ROLE_START_DATE).format(
              "YYYY-MM-DD"
            );
            data[index].ROLE_END_DATE = moment(data[index].ROLE_END_DATE).format(
              "YYYY-MM-DD"
            );
          });
          this.dtLoading = false;
          this.dtItems = data;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    editItem(roleMapId) {
      this.$router.push({
        path: `/manage-role/new/${roleMapId}`,
      });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
